import { trans } from "@/service/i18n/i18n";

import { VideoIcon } from "@/svg/sections/video-icon";
import { PublicationIcon } from "@/svg/sections/publication-icon";
import { ClinicalCaseIcon } from "@/svg/sections/clinical-case-icon";
import { TutorialIcon } from "@/svg/sections/tutorial-icon";
import { CalculatorIcon } from "@/svg/sections/calculator-icon";
import { MedsIcon } from "@/svg/sections/meds-icon";
import { InnIcon } from "@/svg/sections/inn-icon";
import { EbookIcon } from "@/svg/sections/ebook-icon";
import { SuperLink as Link } from "@/components/common/super-link";
import { CourseIcon } from "@/svg/sections/course-icon";

export function Icd10TableOfContents({
  videos,
  articles,
  clinicalCases,
  tutorials,
  calculators,
  inns,
  groups,
  ebooks,
  code,
  courses,
}: {
  videos: VideoPreviewType[];
  articles: ArticlePreviewVM[];
  clinicalCases: ClinicalCasePreviewVM[];
  tutorials: TutorialPreviewVM[];
  calculators: CalculatorPreviewVM[];
  inns: InnVM[];
  groups: MedGroupPreviewVM[];
  ebooks: EbookPreviewVM[];
  code: string;
  courses: CoursePreviewVM[];
}) {
  const resourceCounts = {
    videos: videos.length,
    articles: articles.length,
    clinicalCases: clinicalCases.length,
    tutorials: tutorials.length,
    calculators: calculators.length,
    inns: inns.length,
    groups: groups.length,
    ebooks: ebooks.length,
    courses: courses.length,
  };

  const resourceInfo = [
    { label: trans("icd10.video"), id: "videos", icon: <VideoIcon /> },
    { label: trans("icd10.courses"), id: "courses", icon: <CourseIcon /> },
    {
      label: trans("icd10.publications"),
      id: "articles",
      icon: <PublicationIcon />,
    },
    {
      label: trans("icd10.clinical_cases"),
      id: "clinicalCases",
      icon: <ClinicalCaseIcon />,
    },
    {
      label: trans("icd10.tutorials"),
      id: "tutorials",
      icon: <TutorialIcon />,
    },
    {
      label: trans("icd10.calculators"),
      id: "calculators",
      icon: <CalculatorIcon />,
    },
    { label: trans("icd10.ingredients"), id: "inns", icon: <InnIcon /> },
    {
      label: trans("icd10.med"),
      id: "groups",
      icon: <MedsIcon />,
      highlight: {
        featureKey: "med-icd10-link",
        title: "Leki powiązane z kodami ICD-10",
        description:
          "Powiązaliśmy nasze leki z kodami tak, by móc jednym kliknięciem przejść do odpowiedniej klasyfikacji.",
      },
    },
    { label: trans("icd10.ebooks"), id: "ebooks", icon: <EbookIcon /> },
  ];

  const filtered = resourceInfo.filter(
    (resource) => resourceCounts[resource.id] > 0,
  );

  if (filtered.length === 0) {
    return <></>;
  }

  return (
    <div className={"my-8"}>
      <div className={`text-sm font-normal text-zinc-600`}>
        Powiązane z{" "}
        <strong>
          <em>{code}</em>
        </strong>
        :
      </div>
      <div className={"relative mt-3 flex flex-wrap items-center gap-2"}>
        {filtered.map((resource) => {
          const link = (
            <Link
              href={`#anchor-for-${resource.id}`}
              key={resource.label}
              className={
                "hover:bg-remedium-blue/10 text-remedium-blue [&_path]:fill-remedium-blue flex items-center justify-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium no-underline! transition-all"
              }
            >
              {resource.icon}
              {resource.label} ({resourceCounts[resource.id]})
            </Link>
          );

          return link;
        })}
      </div>
    </div>
  );
}
